import { CSSObject } from '@emotion/react'
import { sharedColors } from '../../sharedStyles/colors'

/* Styling for scheduled time wrapper */
const getScheduledTimeWrapper = (isMobile: boolean): CSSObject => ({
  margin: isMobile ? '24px 0 13px 16px' : '21px 0 18px 17px',
  fontSize: '15px',
  color: sharedColors.medGreyText,
})

/* Styling for twitter icons */
const getTwitterIcons = (isMobile: boolean): CSSObject => ({
  alignItems: 'center',
  borderTop: '1px solid #e6ecf0',
  color: sharedColors.medGreyText,
  display: 'flex',
  justifyContent: 'space-between',
  listStyleType: 'none',
  margin: '0 16px',
  padding: isMobile ? '11px 52px 8px 50px' : '14px 78px 11px 78px',
})

const styles = {
  getScheduledTimeWrapper,
  getTwitterIcons,
}

export { styles }
